module.exports = __webpack_public_path__ + "static/media/hamburger.f481cc45.svg";